import React, { useState } from 'react'
import { Link } from 'react-router-dom'
// Components
import BlogCard from '../components/BlogCard'
import PageTransition from '../components/PageTransition'
import LinksMap from '../components/LinksMap'
// CSS
import '../assets/css/blogs.css'

export default function Blogs() {
  const [sideContentShow, setSideContentShow] = useState(false);
  
  return (
    <div className='blogs_page'>
      <PageTransition />
      <LinksMap linksArr={[{name: 'Home', path: '/', active: false}, {name: 'Blogs', path: '/blogs', active: true}]} pageName='Blogs' />
      <div className='container'>
        <div className='left'>
          <div className='blogs_container'>
            <BlogCard
              thumbnail="https://images.unsplash.com/photo-1518791841217-8f162f1e1131?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60"
              title="Fashion Trends"
              description="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras non placerat mi. Etiam non tellus sem. Aenean pretium convallis lorem, sit amet dapibus ante mollis a. Integer bibendum interdum sem, eget volutpat purus pulvinar in"
              date="SEPTEMBER 30, 2019"
              author="Joe Doe"
              categories={[{name: 'Lifestyle', link: 'lifestyle'}, {name: 'Men', link: 'Mens'}]}
              likes={12}
            />
            <BlogCard
              thumbnail="https://images.unsplash.com/photo-1518791841217-8f162f1e1131?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60"
              title="Fashion Trends"
              description="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras non placerat mi. Etiam non tellus sem. Aenean pretium convallis lorem, sit amet dapibus ante mollis a. Integer bibendum interdum sem, eget volutpat purus pulvinar in"
              date="SEPTEMBER 30, 2019"
              author="Joe Doe"
              categories={[{name: 'Lifestyle', link: 'lifestyle'}, {name: 'Men', link: 'Mens'}]}
              likes={12}
            />
            <BlogCard
              thumbnail="https://images.unsplash.com/photo-1518791841217-8f162f1e1131?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60"
              title="Fashion Trends"
              description="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras non placerat mi. Etiam non tellus sem. Aenean pretium convallis lorem, sit amet dapibus ante mollis a. Integer bibendum interdum sem, eget volutpat purus pulvinar in"
              date="SEPTEMBER 30, 2019"
              author="Joe Doe"
              categories={[{name: 'Lifestyle', link: 'lifestyle'}, {name: 'Men', link: 'Mens'}]}
              likes={12}
            />
            <BlogCard
              thumbnail="https://images.unsplash.com/photo-1518791841217-8f162f1e1131?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60"
              title="Fashion Trends"
              description="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras non placerat mi. Etiam non tellus sem. Aenean pretium convallis lorem, sit amet dapibus ante mollis a. Integer bibendum interdum sem, eget volutpat purus pulvinar in"
              date="SEPTEMBER 30, 2019"
              author="Joe Doe"
              categories={[{name: 'Lifestyle', link: 'lifestyle'}, {name: 'Men', link: 'Mens'}]}
              likes={12}
            />
          </div>

          <div className='pagination'>
            <Link to='/blogs/page/4' className='fas fa-chevron-left'></Link>
            <Link to='/blogs/page/1'>1</Link>
            <Link to='/blogs/page/2'>2</Link>
            <Link to='/blogs/page/4' className='fas fa-chevron-right'></Link>
          </div>
        </div>
        <div className={sideContentShow? 'right show' : 'right'}>
          <div className='right_section_toggle_btn' onClick={() => {setSideContentShow(!sideContentShow)}}>
            <span className='fas fa-sliders-h'></span>
          </div>
          <section className='about'>
            <div className='section_title'>About The Blog</div>

            <div className='content'>
              <p>Lorem ipsum dolor sit amet, consectetur elit porta. Vestibulum ante justo, volutpat quis porta diam.</p>
            </div>
          </section>

          <section className='search'>
            <div className='content'>
              <form className='search_form'>
                <div className='input_container'>
                  <input type='text' placeholder='Search' />
                  <button className='fas fa-search'></button>
                </div>
              </form>
            </div>
          </section>

          <section className='recent_posts'>
            <div className='section_title'>Recent Posts</div>

            <div className='content'>
              <div className='item'>
                <span>SEPTEMBER 30, 2019</span>
                <Link to='/blogs/post'>Fation Trends</Link>
              </div>
              <div className='item'>
                <span>SEPTEMBER 30, 2019</span>
                <Link to='/blogs/post'>Fation Trends</Link>
              </div>
              <div className='item'>
                <span>SEPTEMBER 30, 2019</span>
                <Link to='/blogs/post'>Fation Trends</Link>
              </div>
            </div>
          </section>

          <section className='recent_comments'>
            <div className='section_title'>Recent Comments</div>

            <div className='content'>
              <div className='item'>
                <span>Alex on</span>
                <Link to='/blogs/post'>Fation Trends</Link>
              </div>
              <div className='item'>
                <span>Alex on</span>
                <Link to='/blogs/post'>Fation Trends</Link>
              </div>
              <div className='item'>
                <span>Alex on</span>
                <Link to='/blogs/post'>Fation Trends</Link>
              </div>
            </div>
          </section>

          <section className='categories'>
            <div className='section_title'>Categories</div>

            <div className='content'>
              <div className='item'>
                <Link to='/blogs/category/lifestyle'>Lifestyle (02)</Link>
                <div className='sub_item'>
                  <Link to='/blogs/category/lifestyle/1'>Lifestyle (01)</Link>
                  <Link to='/blogs/category/lifestyle/2'>Lifestyle (12)</Link>
                </div>
              </div>
              <div className='item'>
                <Link to='/blogs/category/lifestyle'>Lifestyle (22)</Link>
              </div>
              <div className='item'>
                <Link to='/blogs/category/lifestyle'>Lifestyle (09)</Link>
              </div>
              <div className='item'>
                <Link to='/blogs/category/lifestyle'>Lifestyle (0)</Link>
              </div>
              <div className='item'>
                <Link to='/blogs/category/lifestyle'>Uncategorised (02)</Link>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  )
}
